export default "__VITE_ASSET__bac11eae__"